__turbopack_context__.v({
  "linkWrapper": "styles-module-scss-module__2AJEHG__linkWrapper",
});
